<div>
	<div class="ibox-title">
		<h5>Today's Visitor Snapshot</h5>
	</div>

	<div class="ibox-content">
		<div class="StatGrid">
			<label>Signed In:</label>
			<p>{{ InCount }}</p>

			<label>Signed Out:</label>
			<p>{{ OutCount }}</p>

			<label>System Signed Out:</label>
			<p>{{ SysOutCount }}</p>

			<label>In Building:</label>
			<p>{{ InBuildingCount }}</p>

			<label>Visitor Denied Entry:</label>
			<p>{{ DenyCount }}</p>
		</div>
	</div>
</div>
